import { useNavigate, useSearchParams } from "react-router-dom";
import { TemplatePickerModal } from "../components/policyBuilder/TemplatePickerModal.js";
import { usePersistedAdminEnvironment } from "../hooks/usePersistedAdminEnvironment.js";
import type { PolicyTemplate } from "../components/policyBuilder/templates.js";

/**
 * Route: /policies/new
 *
 * Opens the template picker immediately. Selecting a template navigates to
 * PolicyEditPage pre-populated with the chosen template. Closing without
 * selecting navigates back to the policies list.
 */
export const NewPolicyPage = () => {
  const [search] = useSearchParams();
  const navigate = useNavigate();
  const [persistedEnv] = usePersistedAdminEnvironment();
  const envParam = search.get("env");
  const env =
    envParam === "production" ? "production" : envParam === "sandbox" ? "sandbox" : persistedEnv;

  const handleSelect = (t: PolicyTemplate) => {
    void navigate(`/policies/${encodeURIComponent(t.actionType)}?env=${env}&templateId=${t.id}`, {
      replace: true
    });
  };

  const handleStartBlank = (actionType: string) => {
    void navigate(`/policies/${encodeURIComponent(actionType)}?env=${env}`, { replace: true });
  };

  const handleClose = () => {
    void navigate("/policies", { replace: true });
  };

  return (
    <TemplatePickerModal
      opened
      onClose={handleClose}
      onSelect={handleSelect}
      onStartBlank={handleStartBlank}
    />
  );
};
